module.exports = __webpack_public_path__ + "static/media/power.7425f0e1.svg";